import { render, staticRenderFns } from "./addIntranetSecondHandCar.vue?vue&type=template&id=56bc9fa8&scoped=true"
import script from "./addIntranetSecondHandCar.vue?vue&type=script&lang=js"
export * from "./addIntranetSecondHandCar.vue?vue&type=script&lang=js"
import style0 from "./addIntranetSecondHandCar.vue?vue&type=style&index=0&id=56bc9fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc9fa8",
  null
  
)

export default component.exports